import { render, staticRenderFns } from "./tabBar.vue?vue&type=template&id=0669bb87&scoped=true&"
import script from "./tabBar.vue?vue&type=script&lang=js&"
export * from "./tabBar.vue?vue&type=script&lang=js&"
import style0 from "./tabBar.vue?vue&type=style&index=0&id=0669bb87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0669bb87",
  null
  
)

export default component.exports